// default ScrollOut for text
new ScrollOut({
  once: true,
  treshold: 0.3
});

// images
new ScrollOut({
  targets: '[data-scroll-image]',
  cssProps: {
    visibleY: true,
    viewportY: true
  }
});
